export default {
  methods: {
    checkUserFeature(name, storeIn) {
      let user;
      try {
        // user = this.$store.state.currentUser.user;
        user = (this.$store || storeIn).state.currentUser.user;
      } catch (_e) {
        user = {};
      }
      const { rol, allowedUserFeatures, allowedFrontRoutesNames } = user;

      // Si se usa la autorización por rutas se salta la validación por características
      if (allowedFrontRoutesNames && allowedFrontRoutesNames.length !== 0) {
        return true;
      }
      // Si se usa la autorización por rol se salta la validación por características
      if (rol) {
        return true;
      }
      // Si no hay userFeatures se salta la validación de estas
      if (!allowedUserFeatures || allowedUserFeatures.length === 0) {
        return true;
      }
      return allowedUserFeatures.includes(name);
    }
    /* checkUserFeature(name, storeIn) {
      let user;
      try {
        // user = this.$store.state.currentUser.user;
        user = (this.$store || storeIn).state.currentUser.user;
      } catch (e) {
        user = {};
      }
      const { isUserFeaturesActive, allowedUserFeatures } = user;
      if (isUserFeaturesActive) {
        const result = allowedUserFeatures.includes(name);
        return result;
      }
      return true;
    } */

  }
};
